import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { EtatGlobalContext } from "../../EtatGlobal";
import { decoderPositionAudit } from "../DocTypes/LMAUDIT/auditSignature";
import { httpClient, authFetch } from "../../../HttpClient";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "./styles/DetailsSIgn.css";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../../assets/images/logo.webp";
import {
  Send,
  Shield,
  CheckCircle2,
  User,
  Mail,
  FileText,
  Copy,
  ExternalLink,
  FileKey,
  CheckCircle,
} from "lucide-react";
import { Button } from "../../../components/ui/button.js";

import { dialog } from "../../../components/ui/Dialog"; // import { toast } from "sonner";
import { referenceDuBrouillon } from "../lmBrouillon.js";
import { LM_LIBRE, nomDocumentLM, SIGNATURE_CABINET_LIBRE, SIGNATURE_CLIENT_LIBRE } from "../DocTypes/LMLIBRE/lmLibreDocument.js";

// Modèles Word (public/) dont le bloc de signature porte les repères DocuSign
// \s1\ et \s2\ (28/10/2026). Même liste côté backend
// (services/lmSignaturePositions.js).
const MODELES_A_REPERES = new Set([
  "LM micro entreprise.docx",
  "LM BNC.docx",
  "LM Création de société.docx",
  "LM social ponctuelle.docx",
  "LM Prévisionnel.docx",
  "LM Evaluation.docx",
  "LM sociale.docx",
  "LM Globale EI.docx",
  "LM IR.docx",
  "LM Globale SCTE.docx",
  "LM Situation.docx",
  "LM Audit d'acquisition.docx",
]);

const SendDocForm = ({
  pdfUrl,
  nom_client,
  email,
  comptable,
  selectedForm,
  leadId,
  clientId,
  //
  civilite_lm,
  nom,
  prenom,
  telephone,
  siren,
  nombreLignesTableau,
  nombreLignesTexteLibre,
  formeSociale,
  societeNom,
  avenant,
}) => {
  const navigate = useNavigate();
  const [emailSubject, setEmailSubject] = useState("");
  // Lignes du tableau HONO (diligences) — transmises au backend pour que le
  // webhook DocuSign détecte une dissolution/liquidation (LM Sécrétariat juridique).
  // formData fournit aussi le cabinet sélectionné (lieu_collab), stocké sur
  // l'Envelope pour piloter le mandat SEPA envoyé à J+1 de la signature.
  const { rows, formData, brouillonLm } = useContext(EtatGlobalContext);
  const cabinet = formData?.lieu_collab?.trim() || null;
  console.log({
    "-- poprs --": {
      pdfUrl,
      nom_client,
      email,
      comptable,
      selectedForm,
      leadId,
      clientId,
      civilite_lm,
      nom,
      prenom,
      telephone,
      siren,
      nombreLignesTableau,
      formeSociale,
      societeNom,
      avenant,
      cabinet,
    },
  });

  const signaturePositions = {
    "LM micro entreprise.docx": {
      pageNumber: 7,
      xPosition: 100,
      yPosition: 500 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM BNC.docx": {
      pageNumber: 4,
      xPosition: 100,
      yPosition: 405 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Création de société.docx": {
      pageNumber: 5,
      xPosition: 100,
      // + décalage lié au texte libre (compteur dédié, indépendant du
      // tableau d'honoraires qui pilote déjà nombreLignesTableau pour ce document)
      yPosition:
        425 +
        Math.max(0, nombreLignesTableau - 1) * 15 +
        Math.max(0, nombreLignesTexteLibre || 0) * 15,
    },
    // Repères du modèle Word (28/10/2026) : la signature suit le texte, même
    // avec une activité ou des diligences longues. `repli` = ancienne
    // position fixe, reprise par le backend si le PDF n'a pas de repère.
    "LM Sécrétariat juridique.docx": {
      ...SIGNATURE_CLIENT_LIBRE,
      repli: { pageNumber: 4, xPosition: 100, yPosition: 325 + Math.max(0, nombreLignesTableau - 1) * 25 },
    },
    "LM social ponctuelle.docx": {
      pageNumber: 4,
      xPosition: 100,
      yPosition: 300 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    // ajuster ke 4 Juillet
    "LM Prévisionnel.docx": {
      pageNumber: 4,
      xPosition: 100,
      yPosition: 600 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Evaluation.docx": {
      pageNumber: 4,
      xPosition: 100,
      yPosition: 500 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM sociale.docx": {
      pageNumber: 7,
      xPosition: 100,
      yPosition: 725,
    },
    "LM Globale EI.docx": {
      pageNumber: 10,
      xPosition: 100,
      yPosition: 550 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM BG Logiciel.docx": {
      pageNumber: 1,
      xPosition: 135,
      yPosition: 700,
    },
    "BON DE COMMANDE.docx": {
      pageNumber: 1,
      xPosition: 135,
      yPosition: 700,
    },
    "LM BC RBE.docx": {
      pageNumber: 1,
      xPosition: 135,
      yPosition: 665,
    },
    "LM IR.docx": {
      pageNumber: 3,
      xPosition: 100,
      yPosition: 575,
    },
    "LM Globale SCTE.docx": {
      pageNumber: 10,
      xPosition: 100,
      yPosition: 575 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Situation.docx": {
      pageNumber: 4,
      xPosition: 100,
      yPosition: 325 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    // Page et y calculés selon les lignes cochées du §2.2 (auditSignature.js) :
    // nombreLignesTableau porte ici le code page × 1000 + y.
    "LM Audit d'acquisition.docx": decoderPositionAudit(nombreLignesTableau, 100),
    // LM libre : ancre DocuSign (repère invisible du modèle), page variable.
    [LM_LIBRE]: SIGNATURE_CLIENT_LIBRE,
    default: { pageNumber: 10, xPosition: 100, yPosition: 425 },
  };

  const comptablePositions = {
    "LM micro entreprise.docx": {
      pageNumber: 7,
      xPosition: 355,
      yPosition: 500 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM BNC.docx": {
      pageNumber: 4,
      xPosition: 355,
      yPosition: 405 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Création de société.docx": {
      pageNumber: 5,
      xPosition: 355,
      yPosition:
        425 +
        Math.max(0, nombreLignesTableau - 1) * 15 +
        Math.max(0, nombreLignesTexteLibre || 0) * 15,
    },
    "LM Sécrétariat juridique.docx": {
      ...SIGNATURE_CABINET_LIBRE,
      repli: { pageNumber: 4, xPosition: 355, yPosition: 325 + Math.max(0, nombreLignesTableau - 1) * 25 },
    },
    "LM social ponctuelle.docx": {
      pageNumber: 4,
      xPosition: 355,
      yPosition: 300 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    // ajuster ke 4 Juillet
    "LM Prévisionnel.docx": {
      pageNumber: 4,
      xPosition: 355,
      yPosition: 600 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Evaluation.docx": {
      pageNumber: 4,
      xPosition: 355,
      yPosition: 500 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM sociale.docx": {
      pageNumber: 7,
      xPosition: 355,
      yPosition: 725,
    },
    "LM Globale EI.docx": {
      pageNumber: 10,
      xPosition: 355,
      yPosition: 550 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM IR.docx": {
      pageNumber: 3,
      xPosition: 355,
      yPosition: 575,
    },
    "LM Globale SCTE.docx": {
      pageNumber: 10,
      xPosition: 355,
      yPosition: 575 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Situation.docx": {
      pageNumber: 4,
      xPosition: 355,
      yPosition: 325 + Math.max(0, nombreLignesTableau - 1) * 25,
    },
    "LM Audit d'acquisition.docx": decoderPositionAudit(nombreLignesTableau, 355),
    [LM_LIBRE]: SIGNATURE_CABINET_LIBRE,
    default: { pageNumber: 10, xPosition: 355, yPosition: 425 },
  };

  // Modèles Word dotés des repères \s1\ (client) / \s2\ (cabinet) sous les
  // signatures (28/10/2026) : la signature suit le texte, quelle que soit sa
  // longueur. La position fixe ci-dessus sert de repli, reprise par le
  // backend si le PDF n'a pas de repère (LM générée avec l'ancien modèle).
  const avecRepere = (position, repere) =>
    MODELES_A_REPERES.has(selectedForm) && position && !position.anchorString
      ? { ...repere, repli: position }
      : position;
  const selectedSignature = avecRepere(
    signaturePositions[selectedForm] || signaturePositions["default"],
    SIGNATURE_CLIENT_LIBRE,
  );
  const selectedComptableSignature = avecRepere(
    comptablePositions[selectedForm] || comptablePositions["default"],
    SIGNATURE_CABINET_LIBRE,
  );

  const cleanNomClient =
    nom_client && nom_client.trim() && nom_client.trim().toLowerCase() !== "n/a"
      ? nom_client.trim()
      : "";

  const signers = [
    {
      name:
        cleanNomClient ||
        (nom?.trim() && prenom?.trim()
          ? `${nom.trim()} ${prenom.trim()}`
          : "Signataire"),
      email: email || "",
      signatures: [selectedSignature],
    },
  ];

  if (
    selectedForm !== "LM BG Logiciel.docx" &&
    selectedForm !== "BON DE COMMANDE.docx" &&
    selectedForm !== "LM BC RBE.docx"
  ) {
    if (comptable === "Samuel HOARAU") {
      signers.push({
        name: "Mrs Samuel",
        email: "samuel.hoarau@alfacomptabilite.com",
        // email: "rantsajonathan@gmail.com",
        signatures: [selectedComptableSignature],
      });
    } else if (comptable === "Anthony HOARAU") {
      signers.push({
        name: "Mrs Anthony",
        email: "anthony.hoarau@alfacomptabilite.com",
        signatures: [selectedComptableSignature],
      });
    }
  }

  // Nom du document : nom du modèle, sauf la LM libre (« LM [nom de la mission] »).
  const formWithoutExtension = nomDocumentLM(selectedForm, formData);

  useEffect(() => {
    if (!selectedForm) return;

    const cleanNomClient =
      nom_client?.trim() && nom_client.trim().toLowerCase() !== "n/a"
        ? nom_client.trim()
        : "";

    const finalName =
      cleanNomClient ||
      (nom?.trim() && prenom?.trim()
        ? `${nom.trim()} ${prenom.trim()}`
        : "Client");

    setEmailSubject(`${finalName} - ${formWithoutExtension}`);
  }, [nom_client, nom, prenom, selectedForm, formWithoutExtension]);

  console.log("Formulaire selecionner :", selectedForm, "Cabinet :", cabinet);

  console.log("Liste des signataires :", signers, "Cabinet :", cabinet);

  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [step, setStep] = useState(1); // 1: vérification, 2: transmission, 3: succès

  const handleSubmit = async (e) => {
    if (loading) return;
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Diligences saisies dans le tableau HONO, normalisées (sans le préfixe " - ")
    const diligences = (rows || [])
      .map((r) =>
        (r.abrv || "")
          .replace(/^\s*-\s*/, "")
          .trim()
          .toLowerCase(),
      )
      .filter(Boolean);

    // On envoie un tableau de signataires
    const data = {
      pdfUrl,
      signers,
      emailSubject,
      leadId,
      clientId,
      civilite_lm,
      nom,
      prenom,
      telephone,
      siren,
      email,
      formeSociale,
      societeNom,
      avenant,
      diligences,
      // Cabinet porteur de la LM ("LE TAMPON" / "SAINT-PIERRE")
      cabinet,
      // Référence de la LM déjà attribuée au brouillon (null sinon : le backend
      // en crée une pour les LM, jamais pour les bons de commande).
      reference: referenceDuBrouillon(brouillonLm, formData),
    };

    console.log("Données envoyées à l'API :", data);
    console.log("Cabinet sélectionné pour la LM :", cabinet);

    try {
      const result = await httpClient.post(
        "https://backend-myalfa.vercel.app/api/send-doc",
        data,
      );
      setResponse(result.data);
      console.log("liste des urls", result.data, "Cabinet :", cabinet);

      // Appel conditionnel à l'API DELETE formleads/:leadId
      if (leadId !== null && leadId !== "") {
        const res = await authFetch(
          `https://backend-myalfa.vercel.app/api/formleads/${leadId}`,
          {
            method: "PUT", // ou "PUT" selon ton API
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ status: "LM" }),
          },
        );

        if (!res.ok) {
          throw new Error("Échec de la mise à jour du lead.");
        }

        console.log(
          `Lead mis à jour avec succès : ${leadId} (status: LM)`,
          "Cabinet :",
          cabinet,
        );
      }
    } catch (error) {
      console.error(
        "Erreur lors de l'envoi du document ou suppression du lead :",
        error,
        "Cabinet :",
        cabinet,
      );
      setError(
        error.response?.data ||
          error.message ||
          "Une erreur inconnue est survenue.",
      );
    } finally {
      setLoading(false);
      setStep(2);
    }
  };

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(response.envelopeId);
  };

  const handleSendEmails = async () => {
    if (loading) return;

    if (!response || !response.signingLinks) {
      console.log(
        "Aucune réponse de l'API pour les liens.",
        "Cabinet :",
        cabinet,
      );
      return;
    }

    setLoading(true);

    try {
      console.log("Démarrage de l'envoi des emails...", "Cabinet :", cabinet);
      for (let i = 0; i < response.signingLinks.length; i++) {
        const signerData = response.signingLinks[i];
        const emailData = {
          email: signerData.email,
          url: signerData.url,
          subject: emailSubject,
        };

        await httpClient.post(
          "https://backend-myalfa.vercel.app/api/send-url-email",
          emailData,
        );
        console.log(
          `Email envoyé à ${signerData.email} avec le lien.`,
          "Cabinet :",
          cabinet,
        );
      }
    } catch (error) {
      console.error(
        "Erreur lors de l'envoi des emails :",
        error,
        "Cabinet :",
        cabinet,
      );
      dialog.alert("Une erreur est survenue lors de l'envoi des emails.");
    } finally {
      setLoading(false);
      setStep(3);
    }
  };

  return (
    <>
      <div
        style={{ marginTop: "5%" }}
        className="h-screen bg-gradient-to-br from-slate-50 via-white to-rose-50/30 flex  justify-center overflow-hidden"
      >
        {/* Header décoratif */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#8B1538] via-[#A91D4D] to-[#8B1538]" />

        <div className="w-full max-w-2xl px-4">
          <AnimatePresence mode="wait">
            {step === 3 ? (
              <motion.div
                key="success"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
                className="text-center"
              >
                {/* Animation de succès */}
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{
                    delay: 0.1,
                    type: "spring",
                    stiffness: 200,
                    damping: 15,
                  }}
                  className="relative inline-block mb-6"
                >
                  <div className="absolute inset-0 bg-green-400/20 rounded-full blur-2xl animate-pulse" />
                  <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center shadow-2xl shadow-green-500/30">
                    <CheckCircle
                      className="w-10 h-10 text-white"
                      strokeWidth={2.5}
                    />
                  </div>
                </motion.div>

                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                  className="text-2xl md:text-3xl font-light text-slate-800 mb-3"
                >
                  Liens{" "}
                  <span className="font-semibold text-green-600">envoyés</span>{" "}
                  !
                </motion.h2>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.25 }}
                  className="text-slate-500 mb-6 max-w-md mx-auto"
                >
                  Le signataire recevra un email avec le lien pour signer le
                  document.
                </motion.p>

                {/* Carte de confirmation compacte */}
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="bg-white rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100 p-6 max-w-md mx-auto mb-6"
                >
                  <div className="flex items-center gap-4 mb-4 p-3 bg-slate-50 rounded-2xl">
                    <div className="w-10 h-10 rounded-xl bg-[#8B1538]/10 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-[#8B1538]" />
                    </div>
                    <div className="text-left">
                      <p className="text-xs text-slate-400">Email envoyé à</p>
                      <p className="font-medium text-slate-700 text-sm">
                        {email}
                      </p>
                    </div>
                  </div>

                  <div className="text-left">
                    <p className="text-xs text-slate-400 mb-1.5">Référence</p>
                    <code className="text-xs font-mono text-slate-500 bg-slate-50 px-3 py-2 rounded-lg block truncate">
                      {response.envelopeId}
                    </code>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                >
                  <Button
                    onClick={() => navigate("/home")}
                    className="w-full h-12 rounded-2xl font-medium text-white bg-gradient-to-r from-[#8B1538] to-[#A91D4D] hover:from-[#7A1230] hover:to-[#981845] shadow-lg shadow-[#8B1538]/25 transition-all duration-300"
                  >
                    Fermer
                  </Button>
                </motion.div>
              </motion.div>
            ) : (
              <motion.div
                key={step}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                {/* En-tête compact */}
                <div className="text-center mb-6">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-[#8B1538] to-[#A91D4D] shadow-lg shadow-[#8B1538]/20 mb-4">
                    <FileText className="w-7 h-7 text-white" />
                  </div>
                  <h1 className="text-2xl md:text-3xl font-light text-slate-800">
                    Transmission pour{" "}
                    <span className="font-semibold text-[#8B1538]">
                      signature
                    </span>
                  </h1>

                  {/* Indicateur d'étapes */}
                  <div className="flex items-center justify-center gap-2 mt-4">
                    <div
                      className={`h-1.5 w-12 rounded-full transition-all duration-300 ${
                        step === 1 ? "bg-[#8B1538]" : "bg-green-500"
                      }`}
                    />
                    <div
                      className={`h-1.5 w-12 rounded-full transition-all duration-300 ${
                        step === 2 ? "bg-[#8B1538]" : "bg-slate-200"
                      }`}
                    />
                  </div>
                </div>

                {/* Carte principale */}
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100 overflow-hidden">
                  {/* Bandeau avec étape */}
                  <div className="bg-gradient-to-r from-[#8B1538]/5 to-[#A91D4D]/5 border-b border-[#8B1538]/10 px-6 py-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Shield className="w-4 h-4 text-[#8B1538]" />
                        <span className="text-sm text-[#8B1538] font-medium">
                          {step === 1
                            ? "Vérification des informations"
                            : "Prêt pour l'envoi"}
                        </span>
                      </div>
                      <span className="text-xs text-slate-400 font-medium">
                        Étape {step}/2
                      </span>
                    </div>
                  </div>

                  <div className="p-6 md:p-8">
                    {step === 1 ? (
                      <div>
                        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-4">
                          Informations du destinataire
                        </h2>

                        <div className="grid gap-3">
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.05 }}
                            className="flex items-center gap-3 group"
                          >
                            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-slate-100 group-hover:bg-[#8B1538]/10 flex items-center justify-center transition-colors duration-300">
                              <FileText className="w-4 h-4 text-slate-400 group-hover:text-[#8B1538] transition-colors duration-300" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs text-slate-400">
                                Document{" "}
                              </p>
                              <p className="text-slate-800 text-sm font-semibold">
                                {formWithoutExtension}
                              </p>
                            </div>
                          </motion.div>
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.05 }}
                            className="flex items-center gap-3 group"
                          >
                            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-slate-100 group-hover:bg-[#8B1538]/10 flex items-center justify-center transition-colors duration-300">
                              <User className="w-4 h-4 text-slate-400 group-hover:text-[#8B1538] transition-colors duration-300" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs text-slate-400">
                                Signataire désigné
                              </p>
                              <p className="text-slate-800 text-sm font-semibold">
                                {nom} {prenom}
                              </p>
                            </div>
                          </motion.div>
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.05 }}
                            className="flex items-center gap-3 group"
                          >
                            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-slate-100 group-hover:bg-[#8B1538]/10 flex items-center justify-center transition-colors duration-300">
                              <Mail className="w-4 h-4 text-slate-400 group-hover:text-[#8B1538] transition-colors duration-300" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs text-slate-400">
                                Adresse e-mail
                              </p>
                              <p className="text-slate-800 text-sm font-semibold">
                                {email}
                              </p>
                            </div>
                          </motion.div>
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.05 }}
                            className="flex items-center gap-3 group"
                          >
                            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-slate-100 group-hover:bg-[#8B1538]/10 flex items-center justify-center transition-colors duration-300">
                              <img
                                src={logo}
                                alt="Logo"
                                className="w-4 h-4 text-slate-400 group-hover:text-[#8B1538] transition-colors duration-300"
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs text-slate-400">
                                Représentant légal
                              </p>
                              <p className="text-slate-800 text-sm font-semibold">
                                {comptable}
                              </p>
                            </div>
                          </motion.div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <h2 className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-4">
                          Référence du document
                        </h2>

                        <motion.div
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          className="bg-gradient-to-br from-slate-50 to-slate-100/50 rounded-2xl p-5 border border-slate-200/50"
                        >
                          <div className="flex items-center gap-3 mb-3">
                            <div className="w-8 h-8 rounded-lg bg-white shadow-sm flex items-center justify-center">
                              <FileKey className="w-4 h-4 text-[#8B1538]" />
                            </div>
                            <span className="text-sm text-slate-500">
                              Identifiant de l'enveloppe
                            </span>
                          </div>

                          <div className="flex items-center gap-3 mb-4">
                            <code className="flex-1 text-sm font-mono text-[#8B1538] bg-white px-3 py-2.5 rounded-xl border border-slate-200 truncate">
                              {response.envelopeId}
                            </code>
                            <Button
                              size="icon"
                              onClick={copyToClipboard}
                              className="h-10 w-10 rounded-xl border-slate-200 hover:bg-[#8B1538] hover:text-white hover:border-[#8B1538] transition-all duration-300"
                            >
                              <Copy className="w-4 h-4" />
                            </Button>
                          </div>

                          <div className="flex items-center justify-between gap-4 pt-3 border-t border-slate-200">
                            <div className="text-sm text-slate-500">
                              <span>Créée dans </span>
                              <span className="font-semibold text-slate-700">
                                Docusing
                              </span>
                            </div>

                            <a
                              href="https://apps.docusign.com/send/home"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-flex items-center gap-2 text-xs font-medium text-[#8B1538] hover:text-[#A91D4D] transition-colors group"
                            >
                              <span>Tableau de bord</span>
                              <ExternalLink className="w-3 h-3 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                            </a>
                          </div>
                        </motion.div>
                      </div>
                    )}
                  </div>

                  {/* Footer avec bouton */}
                  <div className="bg-slate-50/50 border-t border-slate-100 px-6 md:px-8 py-5">
                    {step === 2 ? (
                      <div className="flex gap-3">
                        <Button
                          onClick={() => setStep(1)}
                          variant="outline"
                          className="h-12 px-6 rounded-2xl border-slate-200 hover:bg-slate-50"
                        >
                          Retour
                        </Button>
                        <Button
                          onClick={handleSendEmails}
                          disabled={loading}
                          className={`
    flex-1 h-12 rounded-2xl font-medium text-white transition-all duration-300
    ${
      loading
        ? "bg-slate-300 text-slate-500 cursor-not-allowed shadow-none"
        : "bg-gradient-to-r from-[#8B1538] to-[#A91D4D] hover:from-[#7A1230] hover:to-[#981845] shadow-lg shadow-[#8B1538]/25 hover:shadow-xl hover:shadow-[#8B1538]/30 hover:-translate-y-0.5"
    }
  `}
                        >
                          {loading ? (
                            <motion.div
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              className="flex items-center gap-3"
                            >
                              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                              Envoi en cours...
                            </motion.div>
                          ) : (
                            <span className="flex items-center gap-3">
                              <Send className="w-5 h-5" />
                              Envoyer les liens de signatures
                            </span>
                          )}
                        </Button>
                      </div>
                    ) : (
                      <Button
                        onClick={handleSubmit}
                        disabled={loading}
                        className={`
    w-full h-12 rounded-2xl font-medium text-white transition-all duration-300
    ${
      loading
        ? "bg-slate-200 text-slate-500 cursor-not-allowed shadow-none"
        : "bg-gradient-to-r from-[#8B1538] to-[#A91D4D] hover:from-[#7A1230] hover:to-[#981845] shadow-lg shadow-[#8B1538]/25 hover:shadow-xl hover:shadow-[#8B1538]/30 hover:-translate-y-0.5"
    }
  `}
                      >
                        <CheckCircle2 className="w-5 h-5 mr-3" />
                        {loading ? (
                          <span>Traitement du Document ...</span>
                        ) : (
                          <span>Traiter le document à Signer</span>
                        )}
                        {/* Traiter le document à Signer */}
                      </Button>
                    )}
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {error && (
          <div style={{ color: "red", marginTop: "10px" }}>
            Erreur : {error}
          </div>
        )}
      </div>
    </>
  );
};

export default SendDocForm;
